import { QXMLObject } from "./QXMLObject";
import { StringToBool } from "../utils/StringToBool.js";

export class QProfileCol extends QXMLObject {
  constructor() {
    super();
    this.fFillColor = null;
    this.fFillMode = null;
    this.fFontColor = null;
    this.fBold = null;
    this.fItalic = null;
    this.fFreeText = null;
    this.fColType = null;
  }

  InitProfileCol() {
    this.SetXMLElementName("profilecol");
  }

  SetProperties(colType, fillColor, fillMode, fontColor, bold, italic, freeText) {
    this.fColType = colType;
    this.fFillColor = fillColor;
    this.fFillMode = fillMode;
    this.fFontColor = fontColor;
    this.fBold = bold;
    this.fItalic = italic;
    this.fFreeText = freeText;
  }

  GetColType() {
    return this.fColType;
  }

  SetColType(colType) {
    this.fColType = colType;
  }

  GetFillColor() {
    return this.fFillColor;
  }

  SetFillColor(fillColor) {
    this.fFillColor = fillColor;
  }

  GetFillMode() {
    return this.fFillMode;
  }

  SetFillMode(fillMode) {
    this.fFillMode = fillMode;
  }

  GetTextColor() {
    return this.fFontColor;
  }

  SetTextColor(fontColor) {
    this.fFontColor = fontColor;
  }

  GetBold() {
    return this.fBold;
  }

  SetBold(bold) {
    this.fBold = bold;
  }

  SetUnderline(underline) {
    this.fUnderline = underline;
  }

  GetItalic() {
    return this.fItalic;
  }

  SetItalic(italic) {
    this.fItalic = italic;
  }

  GetUnderline() {
    return this.fUnderline;
  }

  GetFreeText() {
    return this.fFreeText;
  }

  SetFreeText(freeText) {
    this.fFreeText = freeText;
  }

  OutputSubElements(stream) {
    this.OutputElementSex(
      "format",
      this.fColType,
      this.fFillColor,
      this.fFillMode,
      this.fFontColor,
      this.fBold,
      this.fItalic,
      stream
    );
    if (this.fFreeText != null) this.OutputSimpleElement("freetext", this.fFreeText, stream);
  }

  OutputToJSON(JSON) {
    var colInfo = { type: this.fColType };
    //TODO: This is currently deprecated.
    //colInfo['format'] = {'fillColor': this.fFillColor, 'fillMode': this.fFillMode, 'fontColor': this.fFontColor, 'bold': this.fBold, 'italic': this.fItalic}

    if (this.fFreeText != null) colInfo["freeText"] = this.fFreeText;
    return colInfo;
  }

  LoadFromJSON(JSON) {
    this.fColType = JSON["type"];

    if (JSON["freeText"]) this.fFreeText = JSON["freeText"];
    var colInfo = { type: this.fColType };
    //colInfo['format'] = {'fillColor': this.fFillColor, 'fillMode': this.fFillMode, 'fontColor': this.fFontColor, 'bold': this.fBold, 'italic': this.fItalic}

    return colInfo;
  }

  LoadChildElements(objTree) {
    var valueList = objTree.GetValueListForChild("format", false);
    this.fColType = parseInt(valueList[0]);
    this.fFillColor = valueList[1];
    this.fFillMode = parseInt(valueList[2]);
    this.fFontColor = valueList[3];
    this.fBold = StringToBool(valueList[4]);
    this.fItalic = StringToBool(valueList[5]);

    var freeText = objTree.GetValueForChild("freetext", false);
    if (freeText) this.fFreeText = freeText;
  }

  CopyFormat(origElement) {
    this.fColType = origElement.fColType;
    this.fFillColor = origElement.fFillColor;
    this.fFillMode = origElement.fFillMode;
    this.fFontColor = origElement.fFontColor;
    this.fBold = origElement.fBold;
    this.fItalic = origElement.fItalic;
    this.fFreeText = origElement.fFreeText;
  }

  Clone() {
    var c = new QProfileCol();
    c.InitProfileCol();

    c.fColType = this.fColType;
    c.fFillColor = this.fFillColor;
    c.fFillMode = this.fFillMode;
    c.fFontColor = this.fFontColor;
    c.fBold = this.fBold;
    c.fItalic = this.fItalic;
    c.fFreeText = this.fFreeText;

    return c;
  }
}
